<template>
  <div class="app-content ap search-class">
    <div class="row mb-4">
      <div class="col">
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__main-title">Text Search and Classification Interface</h1>
        </div>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" @click="resetSearch()">New Search</button>
      </div>
    </div>
    <div class="content-block mb-4">
      <div class="content-block__body">
        <form class="mb-3" @submit.prevent="search()">
          <div class="row">
            <div class="col-3">
              <select name="search_engine" class="form-control" @change="updateSearchEngine">
                <!--<option :selected="searchEngine == null" value="">Select a search engine</option>-->
                <option :selected="searchEngine == 'google'" value="google">Google</option>
                <!--<option :selected="searchEngine == 'bing'" value="bing">Bing</option>-->
                <!--<option :selected="searchEngine == 'all_engines'" value="all_engines">All Engines</option>-->
              </select>
            </div>
            <div class="col">
              <input type="text" name="query" class="form-control" :value="searchQuery" @input="updateSearchQuery" placeholder="Search...">
            </div>
            <div class="col-2">
              <button type="submit" class="btn btn-primary btn-block">Research</button>
            </div>
          </div>
        </form>
        <form class="mb-3">
          <div class="row justify-content-end">
            <div class="col offset-3">
              <input type="file" name="docfile" ref="file" class="form-control-file" @change="processFile()">
            </div>
            <div class="col-2">
              <button class="btn btn-primary btn-block" @click.prevent="searchWithFile()">Load</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row row--less-gutters mb-5">
      <div class="col-lg-6">
        <div class="search-filters">
          <form @submit.prevent="filterArticles()">
            <div class="filters__title">Filter By</div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <label>Tag</label>
                <select name="tag" class="form-control" v-model="filterTag">
                  <option value=""></option>
                  <option value="text">Text</option>
                  <option value="pdf">Pdf</option>
                  <option value="entity">Entity</option>
                  <option value="data">Data</option>
                  <option value="video">Video</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label>Date</label>
                <select name="last-update" class="form-control" v-model="filterUpdate">
                  <option value=""></option>
                  <option value="last-week">Last Week</option>
                  <option value="last-month">Last Month</option>
                  <option value="last-year">Last Year</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label>Language</label>
                <select name="language" class="form-control" v-model="filterLanguage">
                  <option value=""></option>
                  <option value="it">Italian</option>
                  <option value="en">English</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label>Source Score</label>
                <select name="score" class="form-control" v-model="filterScore">
                  <option value=""></option>
                  <option value="5+">Score &gt; 5</option>
                  <option value="5-">Score &lt;= 5</option>
                  <option value="not-scored">Not Scored</option>
                </select>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-sm btn-primary">Apply</button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="search-filters">
          <form @submit.prevent="filterArticles()">
            <div class="filters__title">Order By</div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <label>Tag</label>
                <select name="tag" class="form-control" v-model="sortTag">
                  <option value=""></option>
                  <option value="text">Text</option>
                  <option value="pdf">Pdf</option>
                  <option value="entity">Entity</option>
                  <option value="data">Data</option>
                  <option value="video">Video</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label>Last Update</label>
                <select name="last-update" class="form-control" v-model="sortUpdate">
                  <option value=""></option>
                  <option value="most-recent">Most Recent</option>
                  <option value="less-recent">Less Recent</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label>Language</label>
                <select name="language" class="form-control" v-model="sortLanguage">
                  <option value=""></option>
                  <option value="italian">Italian First</option>
                  <option value="english">English First</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label>Source Score</label>
                <select name="scoring" class="form-control" v-model="sortScore">
                  <option value=""></option>
                  <option value="ascending">Ascending</option>
                  <option value="descending">Descending</option>
                </select>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-sm btn-primary">Apply</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="filteredArticles.length">
      <SearchArticleList :filteredArticles="filteredArticles" :searchByFile="searchByFile"/>
    </div>
    <div class="text-center py-5" v-else-if="articles.length">
      <p>No results with these search filters, <strong>try to change them</strong></p>
    </div>
    <div class="text-center py-5" v-else>
      <p>Select a search engine, enter a query and click <strong>Research</strong></p>
    </div>
    <div class="text-center mt-4" v-if="articles.length">
      <button class="btn btn-primary" @click.prevent="loadMoreArticles()">Load More</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import SearchArticleList from "@/components/SearchArticleList";
import moment from 'moment';
import {
  RESET_SEARCH,
  FETCH_ARTICLES,
  FETCH_MORE_ARTICLES,
  FETCH_ARTICLES_WITH_FILE
} from "@/store/actions.type";

import {
  SET_SEARCH_ENGINE,
  SET_SEARCH_QUERY,
  SET_SEARCH_BY_FILE,
  SET_FILTERS,
  UPDATE_FILTERED_ARTICLES
} from "@/store/mutations.type";

export default {
  name: 'Search',
  components: {
    SearchArticleList
  },
  data(){
    return { 
      searchFile: null,
      filterTag: null,
      filterUpdate: null,
      filterLanguage: null,
      filterScore: null,
      sortTag: null,
      sortUpdate: null,
      sortLanguage: null,
      sortScore: null
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "articles", "filteredArticles", "filters", "searchEngine", "searchQuery", "searchByFile", "currentArticle"]),
  },
  methods: {
    updateSearchEngine: function(e) {
      this.$store.commit(SET_SEARCH_ENGINE, e.target.value);
    },
    updateSearchQuery: function(e) {
      this.$store.commit(SET_SEARCH_QUERY, e.target.value);
    },
    resetSearch: function() {
      this.$store.commit(SET_SEARCH_BY_FILE, false);
      this.$store.dispatch(RESET_SEARCH);
      this.resetLocalFilters();
      this.searchFile = null;
      this.$refs.file.value = null;
    },
    resetEngineQuery: function() {
      this.$store.dispatch(RESET_SEARCH);
      this.resetLocalFilters();
    },
    resetFile: function() {
      this.$store.commit(SET_SEARCH_BY_FILE, false);
      this.searchFile = null;
      this.$refs.file.value = null;
    },
    search: function() {

      this.$store.commit(SET_SEARCH_ENGINE, 'google');
      this.resetFile();

      if(this.searchEngine == null || this.searchQuery == null) {
        Swal.fire(
          'Missing fields!',
          'You must to select a search engine and enter a search query',
          'warning'
        );
        return;
      }

      Swal.fire({
        title: 'Searching...',
        timerProgressBar: true,
      });
      Swal.showLoading();

      let searchData = new FormData();
      // searchData.set('search_engine', searchEngine);
      searchData.set('search_engine', 'google');
      searchData.set('query', this.searchQuery);

      this.$store.dispatch(FETCH_ARTICLES, searchData)
      .then(() => {
        Swal.close();
      });
    },
    searchWithFile: function() {

      if(!this.searchFile) {
        Swal.fire(
          'Missing file!',
          'Upload a file first',
          'warning'
        );
        return;
      }

      Swal.fire({
        title: 'Loading...',
        timerProgressBar: true,
        allowOutsideClick: false
      });
      Swal.showLoading();

      this.resetEngineQuery();

      this.$store.commit(SET_SEARCH_BY_FILE, true);

      let searchWithFileData = new FormData();
      searchWithFileData.append('docfile', this.searchFile);

      this.$store.dispatch(FETCH_ARTICLES_WITH_FILE, searchWithFileData)
      .then(() => {
        Swal.close();
      });
    },
    loadMoreArticles: function() {
      Swal.fire({
        title: 'Loading more links...',
        timerProgressBar: true,
        allowOutsideClick: false
      });
      Swal.showLoading();

      this.resetLocalFilters();
      this.filterArticles();

      let searchData = new FormData();
      let searchType = undefined;
      if(this.searchByFile) {
        searchData.set('doc_id', this.articles[0].file);
        searchType = 'file';
      } else {
        searchData.set('query_id', this.articles[0].query);
        searchType = 'query';
      }

      let payload = {
        searchData: searchData,
        searchType: searchType
      }

      let lastArticle = this.articles[this.articles.length - 1];

      this.$store.dispatch(FETCH_MORE_ARTICLES, payload)
      .then((response) => {
        Swal.close();
        if(response == 'no-more-links') {
          Swal.fire(
            'Nothing to load!',
            'No more links to load',
            'warning'
          );
        }    
        setTimeout(function() {
          console.log('last article: #', lastArticle.link_id);
          document.getElementById(lastArticle.link_id).scrollIntoView();
        }, 500);
      });
    },
    processFile: function() {
      this.searchFile = this.$refs.file.files[0];
    },
    resetLocalFilters: function() {
      this.filterTag = null;
      this.filterUpdate = null;
      this.filterLanguage = null;
      this.filterScore = null;
      this.sortTag = null;
      this.sortUpdate = null;
      this.sortLanguage = null;
      this.sortScore = null;
    },
    filterArticles: function() {

      let selectedFilters = {
        filters: {
          tag: this.filterTag,
          update: this.filterUpdate,
          language: this.filterLanguage,
          score: this.filterScore
        },
        sort: {
          tag: this.sortTag,
          update: this.sortUpdate,
          language: this.sortLanguage,
          score: this.sortScore
        }
      }

      this.$store.commit(SET_FILTERS, selectedFilters);

      let newFilteredArticles = [];
      for (var j = 0 ; j < this.articles.length; j++) {
        newFilteredArticles.push(this.articles[j]);
      }

      // Filter for Tags
      for (var i = newFilteredArticles.length - 1; i >= 0; i--) {
        if(this.filterTag) {
          switch(this.filterTag) {
            case 'text':
              if(newFilteredArticles[i].isText != true) {
                newFilteredArticles.splice(i, 1);
              }
              break;
            case 'data':
              if(newFilteredArticles[i].isData != true) {
                newFilteredArticles.splice(i, 1);
              }
              break;
            case 'pdf':
              if(newFilteredArticles[i].isPdf != true) {
                newFilteredArticles.splice(i, 1);
              }
              break;
            case 'video':
              if(newFilteredArticles[i].isVideo != true) {
                newFilteredArticles.splice(i, 1);
              }
              break;
            case 'entity':
              if(newFilteredArticles[i].isEntity != true) {
                newFilteredArticles.splice(i, 1);
              }
              break;
          }
        }
      }

      // Filter for Date
      for (var u = newFilteredArticles.length - 1; u >= 0; u--) {
        if(this.filterUpdate) {

          let articleDate = null;
          if(newFilteredArticles[u].published_date != null) {
            articleDate = newFilteredArticles[u].published_date;
          } else if(newFilteredArticles[u].modified_date != null) {
            articleDate = newFilteredArticles[u].modified_date;
          }

          if(articleDate == null) {
            newFilteredArticles.splice(u, 1);
          }

          let lastWeek = moment().subtract(1, 'week');
          let lastMonth = moment().subtract(1, 'month');
          let lastYear = moment().subtract(1, 'year');

          switch(this.filterUpdate) {
            case 'last-week':       
              if(moment(articleDate).isBefore(lastWeek)) {
                newFilteredArticles.splice(u, 1);
              }
              break;
            case 'last-month':
              if(moment(articleDate).isBefore(lastMonth)) {
                newFilteredArticles.splice(u, 1);
              }
              break;
            case 'last-year':
              if(moment(articleDate).isBefore(lastYear)) {
                newFilteredArticles.splice(u, 1);
              }
              break;
          }
        }
      }

      // Filter for Language
      for (var l = newFilteredArticles.length - 1; l >= 0; l--) {
        if(this.filterLanguage) {
          switch(this.filterLanguage) {
            case 'it':
              if(newFilteredArticles[l].language != 'it') {
                newFilteredArticles.splice(l, 1);
              }
              break;
            case 'en':
              if(newFilteredArticles[l].language != 'en') {
                newFilteredArticles.splice(l, 1);
              }
              break;
          }
        }
      }

      // Filter for Score
      for (var s = newFilteredArticles.length - 1; s >= 0; s--) {
        if(this.filterScore) {
          switch(this.filterScore) {
            case '5+':
              if(newFilteredArticles[s].source_score <= 5 || newFilteredArticles[s].source_score == null) {
                newFilteredArticles.splice(s, 1);
              }
              break;
            case '5-':
              if(newFilteredArticles[s].source_score > 5 || newFilteredArticles[s].source_score == null) {
                newFilteredArticles.splice(s, 1);
              }
              break;
            case 'not-scored':
              if(newFilteredArticles[s].source_score != null) {
                newFilteredArticles.splice(s, 1);
               }
              break;
          }
        }
      }

      // Sort for Tag
      let articlesToMove = [];
      if(this.sortTag) {

        for (var st = newFilteredArticles.length - 1; st >= 0; st--) {  

          switch(this.sortTag) {
            case 'text':
              if(newFilteredArticles[st].isText == true) {
                articlesToMove.push(newFilteredArticles[st]);
                newFilteredArticles.splice(st, 1);
              }
              break;
            case 'pdf':
              if(newFilteredArticles[st].isPdf == true) {
                articlesToMove.push(newFilteredArticles[st]);
                newFilteredArticles.splice(st, 1);
              }
              break;
            case 'entity':
              if(newFilteredArticles[st].isEntity == true) {
                articlesToMove.push(newFilteredArticles[st]);
                newFilteredArticles.splice(st, 1);
              }
              break;
            case 'data':
              if(newFilteredArticles[st].isData == true) {
                articlesToMove.push(newFilteredArticles[st]);
                newFilteredArticles.splice(st, 1);
              }
              break;
            case 'video':
              if(newFilteredArticles[st].isVideo == true) {
                articlesToMove.push(newFilteredArticles[st]);
                newFilteredArticles.splice(st, 1);
              }
              break;
          }

        }

        if(articlesToMove.length) {
          for (var stm = 0; stm < articlesToMove.length; stm++) {
            newFilteredArticles.unshift(articlesToMove[stm]);
          }
        }
      }

      // Sort for Date
      if(this.sortUpdate) {

        switch(this.sortUpdate) {
          case 'most-recent':
            newFilteredArticles.sort((a, b) => {
              if ( a.published_date > b.published_date ){
                return -1;
              }
              if ( a.published_date < b.published_date ){
                return 1;
              }
              return 0;
            });
            break;
          case 'less-recent':
            newFilteredArticles.sort((a, b) => {
              if ( a.published_date < b.published_date ){
                return -1;
              }
              if ( a.published_date > b.published_date ){
                return 1;
              }
              return 0;
            });
            break;
        }

        let articlesWithoutDate = [];
        for (var su = newFilteredArticles.length - 1; su >= 0; su--) {
          if(newFilteredArticles[su].published_date == null) {
            articlesWithoutDate.push(newFilteredArticles[su]);
            newFilteredArticles.splice(su, 1);
          }
        }

        if(articlesWithoutDate.length) {
          for (var sum = 0; sum < articlesWithoutDate.length; sum++) {
            newFilteredArticles.push(articlesWithoutDate[sum]);
          }
        }
      }

      // Sort for Language
      let articlesWithLanguage = [];
      if(this.sortLanguage) {

        for (var sl = newFilteredArticles.length - 1; sl >= 0; sl--) {  

          switch(this.sortLanguage) {
            case 'italian':
              if(newFilteredArticles[sl].language == 'it') {
                articlesWithLanguage.push(newFilteredArticles[sl]);
                newFilteredArticles.splice(sl, 1);
              }
              break;
            case 'english':
              if(newFilteredArticles[sl].language == 'en') {
                articlesWithLanguage.push(newFilteredArticles[sl]);
                newFilteredArticles.splice(sl, 1);
              }
              break;
          }

        }

        if(articlesWithLanguage.length) {
          for (var slm = 0; slm < articlesWithLanguage.length; slm++) {
            newFilteredArticles.unshift(articlesWithLanguage[slm]);
          }
        }
      }

      // Sort for Score
      if(this.sortScore) {
        switch(this.sortScore) {
          case 'ascending':
            newFilteredArticles.sort((a, b) => {
              if ( a.source_score < b.source_score ){
                return -1;
              }
              if ( a.source_score > b.source_score ){
                return 1;
              }
              return 0;
            });
            break;
          case 'descending':
            newFilteredArticles.sort((a, b) => {
              if ( a.source_score > b.source_score ){
                return -1;
              }
              if ( a.source_score < b.source_score ){
                return 1;
              }
              return 0;
            });
            break;
        }
      }

      this.$store.commit(UPDATE_FILTERED_ARTICLES, newFilteredArticles);
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
      return;
    }

    if(this.filters) {
      this.filterTag = this.filters.filters.tag;
      this.filterUpdate = this.filters.filters.update;
      this.filterLanguage = this.filters.filters.language;
      this.filterScore = this.filters.filters.score;
      this.sortTag = this.filters.sort.tag;
      this.sortUpdate = this.filters.sort.update;
      this.sortLanguage = this.filters.sort.language;
      this.sortPertinency = this.filters.sort.score;
    }

    if(this.currentArticle) {
      document.getElementById(this.currentArticle.link_id).scrollIntoView();
    }
  }
}
</script>
